import { DialogContent } from '../components/ui/dialog';
import { usePortalDestination } from './PortalDestinationContext';
import { buildPharmacyTokens } from './lib/portalTheme';
import { usePortalTheme } from './PortalThemeContext';

export const PortalDialogContent = ({ className = '', children, style, ...props }) => {
  const destination = usePortalDestination();
  const { theme } = usePortalTheme();
  return (
    <DialogContent {...props} style={{ ...buildPharmacyTokens(destination?.pharmacy, theme), ...style }}
      className={`portal-brand portal-dialog ${className}`}
      closeProps={{ 'data-testid': `${props['data-testid']}-close`, 'aria-label': 'Close dialog' }}>
      {children}
    </DialogContent>
  );
};